import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "gfu-project-summary-pledge" }
const _hoisted_2 = { class: "gfu-1of1" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = {
  key: 1,
  class: "gfu-project-summary-action"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_project_summary_box_header = _resolveComponent("project-summary-box-header")
  const _component_project_summary_gift_cards = _resolveComponent("project-summary-gift-cards")
  const _component_back_project_button = _resolveComponent("back-project-button")
  const _component_project_summary_follow = _resolveComponent("project-summary-follow")
  const _component_project_summary_box = _resolveComponent("project-summary-box")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_project_summary_box, null, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_base_icon, {
            name: "brand-outline",
            "icon-namespace": "ga",
            size: "2x",
            class: "_tc--accent"
          }),
          _createVNode(_component_project_summary_box_header, null, {
            header: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.Resources.ProjectHome.ProjectSummaryBoxPreorderHeader), 1 /* TEXT */)
            ]),
            subheader: _withCtx(() => [
              _createElementVNode("div", {
                innerHTML: _ctx.Resources.ProjectHome.ProjectSummaryBoxPreorderSubHeader
              }, null, 8 /* PROPS */, _hoisted_3)
            ]),
            _: 1 /* STABLE */
          })
        ])
      ]),
      actions: _withCtx(() => [
        ($options.isGiftCardsVisible)
          ? (_openBlock(), _createBlock(_component_project_summary_gift_cards, { key: 0 }))
          : _createCommentVNode("v-if", true),
        (!_ctx.hasAnyOrder && $options.isPledgeAvailable)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_back_project_button)
            ]))
          : _createCommentVNode("v-if", true),
        (!_ctx.hasAnyOrder)
          ? (_openBlock(), _createBlock(_component_project_summary_follow, { key: 2 }))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    })
  ]))
}